import Vue from 'vue'
import Router from 'vue-router'

import NotFound from '../components/404'
import Home from "../components/Home";
import HomeV2 from "../components/index/HomeV2";
import TimeConverter from "../components/TimeConverter";
import HomePage from "../components/index/HomePage";
import AboutSite from "../components/index/AboutSite";
import CpuZone from "../components/index/CpuZone";
import GpuZone from "../components/index/GpuZone";
import EmpireEarth from "../components/index/EmpireEarth";
import MyBlog from "../components/index/MyBlog";
import SmallTool from "../components/index/SmallTool";
import LeaveMessage from "../components/index/LeaveMessage";
import Register from "../components/Register";
import Login from "../components/Login";






Vue.use(Router)

export default new Router({
  mode: 'history',  // 去掉路由地址的#
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    }
    ,{
      path: '/HomeV2',
      name: 'HomeV2',
      component: HomeV2,
      children:[
        {
          path:'HomePage',
          name:'HomePage',
          component:HomePage
        }, {
          path:'AboutSite',
          name:'AboutSite',
          component:AboutSite
        },{
          path:'CpuZone',
          name:'CpuZone',
          component:CpuZone
        },{
          path:'GpuZone',
          name:'GpuZone',
          component:GpuZone
        },{
          path:'EmpireEarth',
          name:'EmpireEarth',
          component:EmpireEarth
        },{
          path:'MyBlog',
          name:'MyBlog',
          component:MyBlog
        },{
          path:'SmallTool',
          name:'SmallTool',
          component:SmallTool
        },{
          path:'LeaveMessage',
          name:'LeaveMessage',
          component:LeaveMessage
        }
      ]
    }
    ,{
      path: '/tools/time',
      name: 'TimeConverter',
      component: TimeConverter
    }, {
      path:'/Register',
      name:'Register',
      component:Register
    }, {
      path:'/Login',
      name:'Login',
      component:Login
    },{
      path: '*',
      name: 'NotFound',
      component: NotFound
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js